export const megenCostEN = {
  "megen.cost.allJobs": "AI calls and FFmpeg jobs",
  "megen.cost.ffmpegSummary": "FFmpeg usage summary",
  "megen.cost.recordCostCurrency": "Cost (USD or stated currency)",
  "megen.cost.ffmpegPartialCost": "Known subtotal; some job costs remain unknown or use another currency",
  "megen.cost.ffmpegUsage": "FFmpeg: {count} jobs · known allocated instance time {allocated} seconds · known compute time {compute} seconds",
  "megen.cost.ffmpegKnownCosts": "FFmpeg cost: {costs}",
  "megen.cost.ffmpegUnknown": "Cost unknown for {costs} jobs; allocated time unknown for {times} jobs. These jobs are not free; the USD total includes only priced jobs.",
  "megen.cost.ffmpegActive": "{count} jobs are pending or running; allocations may change.",
  "megen.cost.ffmpegScope": "Includes GPUHub segment rendering and merging, including failed work. The USD total uses the task cost when recorded; otherwise it is calculated from allocated time using the dedicated FFmpeg price in the price book. Other currencies stay separate. Local FFmpeg runs are outside this report.",
  "megen.cost.ffmpegAllocated": "Allocated instance time: {seconds} seconds",
  "megen.cost.ffmpegCompute": "Compute time: {seconds} seconds",
  "megen.cost.ffmpegCostUnknown": "Cost unknown",
  "megen.cost.ffmpegErrorDetails": "View FFmpeg task error",
  "megen.cost.ffmpegErrorMissing": "No error details were recorded for this task.",
  "megen.cost.ffmpegNoUsdAllocation": "No priced USD allocation",
  "megen.cost.ffmpegPartialTime": "Known allocated time only; some job times remain unknown",
  "megen.cost.ffmpegTimeUnknown": "Allocated time unknown",
  "megen.cost.projectTab": "By Project",
  "megen.cost.projectName": "Project",
  "megen.cost.projectTable": "Project costs",
  "megen.cost.projectThreads": "Threads",
  "megen.cost.projectThread": "Video / Thread",
  "megen.cost.projectCalls": "Calls",
  "megen.cost.projectErrors": "Errors",
  "megen.cost.projectCost": "Cost (USD)",
  "megen.cost.projectLastUsed": "Last used",
  "megen.cost.projectRecords": "View records",
  "megen.cost.projectFilter": "Filter all tabs by project",
  "megen.cost.projectActiveFilter": "Project filter applied to all totals and tabs: {project}",
  "megen.cost.projectUnmatched": "Project not matched",
  "megen.cost.projectNoThread": "Records without a Thread",
  "megen.cost.projectScope": "Costs include all services and repeated calls in the verified date range and selected filters, not the project's lifetime cost. Expand a project to see its threads; select a thread to inspect its records.",
  "megen.cost.projectCoverage": "Project matched: {matched}/{total} records with a Thread; {noThread} records without a Thread.",
  "megen.cost.projectPermissions": "Project metadata follows your access permissions and current thread membership. Unmatched logs may be inaccessible, deleted or unmapped; their costs remain included when the Project filter is All.",
  "megen.cost.projectLoading": "Loading project index: {projects} projects found; {completed}/{total} project thread lists loaded…",
  "megen.cost.projectIncomplete": "Project index is incomplete. Failed project loads: {failed}; conflicting threads: {conflicts}. Unresolved records remain in the unmatched group; do not treat it as an exact project breakdown.",
  "megen.cost.projectRetry": "Reload project index",
  "megen.cost.projectSearch": "Search all projects by name, ID, thread title or user",
  "megen.cost.projectCalculated": "Calculated subtotal, not a complete price",
  "megen.cost.projectMissingPrice": "Price unknown: {count} calls",
  "megen.cost.projectUnknownQuantity": "Billable quantity unknown: {count} calls",
  "megen.cost.projectEstimated": "Estimated pricing: {count} calls",
  "megen.cost.projectEmpty": "No projects match the current records and filters.",
  "megen.cost.start": "Start date",
  "megen.cost.end": "End date",
  "megen.cost.invalidRange": "Start date must be on or before end date.",
  "megen.cost.loading": "Loading {loaded} of {total} records…",
  "megen.cost.unknownTotal": "unknown",
  "megen.cost.cancel": "Cancel loading",
  "megen.cost.incomplete": "The latest request is incomplete. Previous verified results remain displayed. Retry to obtain complete results.",
  "megen.cost.cancelled": "Loading cancelled. Previous verified results remain displayed.",
  "megen.cost.titles": "Title search index: {resolved}/{total} resolved; {failed} failed. Search results may be incomplete until all titles are resolved.",
  "megen.cost.retryTitles": "Retry title index",
  "megen.cost.applied": "Verified range: {start} to {end} ({timezone}); upper bound {upper}",
  "megen.cost.page": "{first}–{last} of {total}",
  "megen.cost.previous": "Previous page",
  "megen.cost.next": "Next page",
  "megen.cost.first": "First page",
  "megen.cost.last": "Last page",
  "megen.cost.all": "All",
  "megen.cost.videoChart": "Videos by {metric}",
  "megen.cost.chartScope": "Chart scope",
  "megen.cost.top": "Top {count}",
  "megen.cost.search": "Search all records, including video titles",
  "megen.cost.threadSearch": "Search all videos by title, thread or user",
  "megen.cost.selectedLogs": "Complete logs in the applied dashboard range and filters",
  "megen.cost.days": "{days} days",
  "megen.cost.originalModel": "Original model in the log: {model}",
  "megen.cost.historicalWan26Model": "Historical log {model}: mapped to {target} using the requested clip length ({seconds} seconds), not process time. Veo POC is excluded by reporting policy; raw data is unchanged.",
  "megen.cost.ambiguousModel": "The log stores only the family name {model}, not the actual priced model. Its automatic price is unknown; do not assume this usage is free.",
  "megen.cost.missingPrice": "Price unknown",
  "megen.cost.legacyOverride": "This legacy name maps to {target}. Your saved override is retained unchanged, but is not automatically merged into the canonical price. Review the price on the canonical model row.",
};

export const megenCostTH: typeof megenCostEN = {
  "megen.cost.allJobs": "จำนวน AI Call และงาน FFmpeg",
  "megen.cost.ffmpegSummary": "สรุปการใช้งาน FFmpeg",
  "megen.cost.recordCostCurrency": "ค่าใช้จ่าย (USD หรือสกุลเงินที่ระบุ)",
  "megen.cost.ffmpegPartialCost": "ยอดเฉพาะส่วนที่ทราบต้นทุน บางงานยังไม่ทราบต้นทุนหรือใช้สกุลเงินอื่น",
  "megen.cost.ffmpegUsage": "FFmpeg: {count} งาน · เวลาเครื่องที่จัดสรรและทราบแล้ว {allocated} วินาที · เวลา compute ที่ทราบแล้ว {compute} วินาที",
  "megen.cost.ffmpegKnownCosts": "ค่าใช้จ่าย FFmpeg: {costs}",
  "megen.cost.ffmpegUnknown": "ยังไม่ทราบต้นทุน {costs} งาน และเวลาเครื่องที่จัดสรร {times} งาน ไม่ได้หมายความว่างานเหล่านี้ฟรี ยอด USD รวมเฉพาะงานที่มีข้อมูลพอให้คิดราคา",
  "megen.cost.ffmpegActive": "มี {count} งานที่รอหรือกำลังทำงาน เวลาและต้นทุนที่จัดสรรอาจเปลี่ยนได้",
  "megen.cost.ffmpegScope": "รวมงาน render segment และ merge บน GPUHub รวมถึงงานที่ล้มเหลว ยอด USD ใช้ค่าใช้จ่ายที่บันทึกในงาน หากไม่มีจะคำนวณจากเวลาเครื่องที่จัดสรรด้วยราคา FFmpeg ใน price book สกุลเงินอื่นแสดงแยก ส่วน FFmpeg ที่รันในเครื่อง backend ยังไม่อยู่ในรายงานนี้",
  "megen.cost.ffmpegAllocated": "เวลาเครื่องที่จัดสรร: {seconds} วินาที",
  "megen.cost.ffmpegCompute": "เวลา compute: {seconds} วินาที",
  "megen.cost.ffmpegCostUnknown": "ยังไม่ทราบต้นทุน",
  "megen.cost.ffmpegErrorDetails": "ดูข้อผิดพลาดของงาน FFmpeg",
  "megen.cost.ffmpegErrorMissing": "งานนี้ไม่มีรายละเอียดข้อผิดพลาดที่บันทึกไว้",
  "megen.cost.ffmpegNoUsdAllocation": "ไม่มีข้อมูลค่าใช้จ่าย USD",
  "megen.cost.ffmpegPartialTime": "เวลาเครื่องเฉพาะส่วนที่ทราบ บางงานยังไม่ทราบเวลาเครื่องที่จัดสรร",
  "megen.cost.ffmpegTimeUnknown": "ยังไม่ทราบเวลาเครื่องที่จัดสรร",
  "megen.cost.projectTab": "ราย Project",
  "megen.cost.projectName": "Project",
  "megen.cost.projectTable": "ค่าใช้จ่ายราย Project",
  "megen.cost.projectThreads": "Thread ย่อย",
  "megen.cost.projectThread": "Video / Thread",
  "megen.cost.projectCalls": "จำนวน Call",
  "megen.cost.projectErrors": "ล้มเหลว",
  "megen.cost.projectCost": "ค่าใช้จ่าย (USD)",
  "megen.cost.projectLastUsed": "ใช้ล่าสุด",
  "megen.cost.projectRecords": "ดู Records",
  "megen.cost.projectFilter": "กรองทุกแท็บด้วย Project",
  "megen.cost.projectActiveFilter": "กรองยอดรวมและทุกแท็บด้วย Project: {project}",
  "megen.cost.projectUnmatched": "ยังจับคู่ Project ไม่ได้",
  "megen.cost.projectNoThread": "รายการที่ไม่มี Thread",
  "megen.cost.projectScope": "รวมทุกบริการและการรันซ้ำตามช่วงเวลาที่ตรวจสอบแล้วและตัวกรองที่เลือก ไม่ใช่ค่าใช้จ่ายตลอดอายุ Project กาง Project เพื่อดู Thread ย่อย และกด Thread เพื่อดู Records ที่นำมาคำนวณ",
  "megen.cost.projectCoverage": "จับคู่ Project ได้ {matched}/{total} รายการที่มี Thread; อีก {noThread} รายการไม่มี Thread",
  "megen.cost.projectPermissions": "ข้อมูล Project เป็นไปตามสิทธิ์ของคุณและการจัดกลุ่ม Thread ปัจจุบัน log ที่จับคู่ไม่ได้อาจไม่มีสิทธิ์เข้าถึง ถูกลบ หรือไม่มี mapping แต่ยังนับราคาในยอดรวมเมื่อเลือกตัวกรอง Project เป็นทั้งหมด",
  "megen.cost.projectLoading": "กำลังโหลดดัชนี Project: พบ {projects} Project; โหลดรายการ Thread แล้ว {completed}/{total} Project…",
  "megen.cost.projectIncomplete": "ดัชนี Project ยังไม่ครบ โหลด Project ล้มเหลว {failed} รายการ; Thread ที่มี mapping ขัดแย้ง {conflicts} รายการ log ที่ยังระบุไม่ได้คงอยู่ในกลุ่มที่จับคู่ไม่ได้ จึงยังไม่ควรถือว่าการแบ่งยอดตาม Project ครบถ้วน",
  "megen.cost.projectRetry": "โหลดดัชนี Project ใหม่",
  "megen.cost.projectSearch": "ค้นหาทุก Project ด้วยชื่อ ID ชื่อ Thread หรือผู้ใช้",
  "megen.cost.projectCalculated": "ยอดที่คำนวณได้ ยังไม่ใช่ราคาครบถ้วน",
  "megen.cost.projectMissingPrice": "ไม่พบราคา {count} Call",
  "megen.cost.projectUnknownQuantity": "ไม่ทราบปริมาณที่คิดเงิน {count} Call",
  "megen.cost.projectEstimated": "ใช้ราคาประมาณ {count} Call",
  "megen.cost.projectEmpty": "ไม่พบ Project ตามรายการและตัวกรองที่เลือก",
  "megen.cost.start": "วันที่เริ่มต้น",
  "megen.cost.end": "วันที่สิ้นสุด",
  "megen.cost.invalidRange": "วันที่เริ่มต้นต้องไม่เกินวันที่สิ้นสุด",
  "megen.cost.loading": "กำลังโหลด {loaded} จาก {total} รายการ…",
  "megen.cost.unknownTotal": "ยังไม่ทราบ",
  "megen.cost.cancel": "ยกเลิกการโหลด",
  "megen.cost.incomplete": "คำขอล่าสุดโหลดไม่ครบ ยังแสดงผลที่ตรวจสอบแล้วจากครั้งก่อน กรุณาลองใหม่เพื่อรับข้อมูลครบถ้วน",
  "megen.cost.cancelled": "ยกเลิกการโหลดแล้ว ยังแสดงผลที่ตรวจสอบแล้วจากครั้งก่อน",
  "megen.cost.titles": "ดัชนีค้นหาชื่อวิดีโอ: {resolved}/{total} รายการ; ล้มเหลว {failed} รายการ ผลค้นหาอาจไม่ครบจนกว่าจะโหลดชื่อครบ",
  "megen.cost.retryTitles": "ลองโหลดดัชนีชื่อใหม่",
  "megen.cost.applied": "ช่วงเวลาที่ตรวจสอบแล้ว: {start} ถึง {end} ({timezone}); ขอบเขตสิ้นสุด {upper}",
  "megen.cost.page": "{first}–{last} จาก {total}",
  "megen.cost.previous": "หน้าก่อนหน้า",
  "megen.cost.next": "หน้าถัดไป",
  "megen.cost.first": "หน้าแรก",
  "megen.cost.last": "หน้าสุดท้าย",
  "megen.cost.all": "ทั้งหมด",
  "megen.cost.videoChart": "วิดีโอตาม {metric}",
  "megen.cost.chartScope": "ขอบเขตกราฟ",
  "megen.cost.top": "อันดับแรก {count}",
  "megen.cost.search": "ค้นหาทุกรายการ รวมชื่อวิดีโอ",
  "megen.cost.threadSearch": "ค้นหาวิดีโอทั้งหมดด้วยชื่อ thread หรือผู้ใช้",
  "megen.cost.selectedLogs": "รายการครบถ้วนตามช่วงเวลาและตัวกรองที่ใช้ใน dashboard",
  "megen.cost.days": "{days} วัน",
  "megen.cost.originalModel": "ชื่อ Model เดิมใน log: {model}",
  "megen.cost.historicalWan26Model": "log เก่า {model}: แสดงเป็น {target} ตามความยาวคลิปที่ขอสร้าง ({seconds} วิ) ไม่ใช่เวลาประมวลผล โดยถือเป็น Wan และไม่นับ Veo POC ตามกฎรายงาน ข้อมูลดิบไม่เปลี่ยน",
  "megen.cost.ambiguousModel": "log บันทึกเพียงชื่อกลุ่ม {model} ไม่ระบุ model จริงที่คิดราคา จึงหาราคาอัตโนมัติไม่ได้ และไม่ควรถือว่าการใช้งานนี้ฟรี",
  "megen.cost.missingPrice": "ไม่พบราคา",
  "megen.cost.legacyOverride": "ชื่อเก่านี้ map ไปที่ {target} ราคาที่คุณบันทึกไว้ยังอยู่ครบ แต่ไม่รวมเข้ากับราคาชื่อมาตรฐานอัตโนมัติ กรุณาตรวจและตั้งราคาที่แถวชื่อมาตรฐาน",
};
